import { TextInput, TextInputProps } from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';
import { ReactElement } from 'react';

export type PatientFilterInputProps = Omit<TextInputProps, 'leftSection' | 'placeholder'> & {
  placeholder?: string;
};

export function PatientFilterInput({
  placeholder = 'Filter patients…',
  ...rest
}: PatientFilterInputProps): ReactElement {
  return <TextInput leftSection={<IconSearch size={14} />} placeholder={placeholder} {...rest} />;
}
